// 用户 mutation types
export const GET_MUSIC_PLAY = 'GET_MUSIC_PLAY'
export const GET_DURATION = 'GET_DURATION'
export const GET_SECONDS = 'GET_SECONDS'
export const GET_INDEX = 'GET_INDEX'
export const GET_MUSICURL = 'GET_MUSICURL'
export const GET_AUDIOTAG = 'GET_AUDIOTAG'
export const GET_AUDIOTAGPLAY = 'GET_AUDIOTAGPLAY'
export const GET_SCENEID = 'GET_SCENEID'
export const SET_COME_FROM = 'SET_COME_FROM'
export const RESET_ALL = 'RESET_ALL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js